import { render, staticRenderFns } from "./BanksList.vue?vue&type=template&id=01664e76&scoped=true&"
import script from "./BanksList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BanksList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BanksList.vue?vue&type=style&index=0&id=01664e76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01664e76",
  null
  
)

export default component.exports